import { Card, Heading, Paragraph, Stack } from 'canoe';
import { ENDPOINTS, connectWithHammock } from 'hammock';
import React from 'react';

import { ContentMetadata } from '@candu-ai/content/types';

import { AuditHistory } from './components/AuditHistory';
import { LockContent } from './components/LockContent';

interface ContentPermissionsProps {
  contentMetadata: ContentMetadata;
  contentId: string;
  authContext: {
    isOwner: boolean;
    isPublisher: boolean;
    customerId: string;
  };
}

export const ContentPermissionsImpl = ({
  contentId,
  contentMetadata,
  authContext,
}: ContentPermissionsProps) => (
  <Stack>
    <Heading size="S">Content Permissions</Heading>
    <Paragraph maxWidth="none">
      Content can be locked so that it is read only for others. In order to lock the content a
      Publisher or organization owner must change the lock status of this content.
    </Paragraph>
    <Stack>
      <LockContent
        {...authContext}
        contentId={contentId}
        entityPermissionId={contentMetadata.entityPermissionId}
      />
      <Card>
        <Heading size="XS">Audit History</Heading>
        <Paragraph maxWidth="none">
          The following users have modified the permissions for this Content
        </Paragraph>
        <AuditHistory contentId={contentId} />
      </Card>
    </Stack>
  </Stack>
);

export const ContentPermissions = connectWithHammock(({ contentId }) => ({
  endpoint: ENDPOINTS.contentMetadata,
  id: contentId,
  resourceName: 'contentMetadata',
}))(ContentPermissionsImpl);
